import { authClient, API } from "../index";
import { safeGet } from "../../utils/safeGet";

export const getBusinessByQrId = (id) => {
  // Validar que el id no sea undefined, null o "undefined" como string
  if (!id || id === "undefined" || id === "null") {
    return Promise.reject(
      new Error("Invalid qrId parameter. qrId is required.")
    );
  }
  return safeGet(`${API}/business/qr/${id}`);
};

export const getBusinessById = (id) => {
  return safeGet(`${API}/business/${id}`);
};

export const getRatingByBusiness = (id) => {
  return authClient().get(`${API}/business/rating/${id}`);
};

export const getComisionByBusiness = (id) => {
  return authClient().get(`${API}/business/comision/${id}`);
};
